<ng-template [ngIf]="true">

  <div class="container_dati_generali">
    <div class="row">
      <div class="col-sm-12">

        <table class="table-striped table aggiunta_classificazione">
          <caption class="sr-only">Tabella esiti</caption>

          <thead>
            <tr>
              <th scope="col" style="width: 20%;">N. esito</th>
              <th scope="col" style="width: 30%;">Tipo</th>
              <th scope="col" style="width: 20%;">Esito</th>
              <th scope="col" style="width: 20%;">Tipo liquidazione</th>
              <th scope="col">Azioni</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let esito of listaEsiti">
              <td>{{esito?.numeroEsito}}</td>
              <td>{{esito?.tipoEsito?.descrizione}}</td>
              <td>{{esito?.esitoPerSocieta?.descrizione}}</td>
              <td>{{esito?.liquidati[0] ? esito?.liquidati[0].tipoLiquidato.label.toUpperCase() : ''}}</td>
              <td>
                <div class="row">
                  <div class="col-sm-3">
                    <a href="javascript:void(0);" (click)="displayEditLiquidatiModal(esito)" aria-label="Modifica esito">
                      <span class="glyphicon glyphicon-pencil" aria-hidden="true"></span>
                      <span class="sr-only">Modifica esito</span>
                    </a>
                  </div>
                  <div class="col-sm-3">
                    <a href="javascript:void(0);" (click)="removeLiquidatiFromEsito(esito)" aria-label="Elimina esito">
                      <span class="glyphicon glyphicon-trash" aria-hidden="true"></span>
                      <span class="sr-only">Elimina esito</span>
                    </a>
                  </div>
                  <div class="col-sm-6"></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>



        <table class="fondo_rischi">
          <caption class="sr-only">Tabella fondo rischi</caption>

          <tbody>
            <tr class="selected_second_level">
              <th scope="row">Importi</th>
              <td></td>
            </tr>

            <tr class="borded">
              <th scope="row">Importo</th>
              <td>{{approssimaImporto(sorteTot) | euro}} &euro;</td>
            </tr>

            <tr class="borded">
              <th scope="row">Interessi</th>
              <td>{{approssimaImporto(interessiTot) | euro}} &euro;</td>
            </tr>

            <tr class="borded">
              <th scope="row">Rivalutazione</th>
              <td>{{approssimaImporto(rivalutazioneTot) | euro}} &euro;</td>
            </tr>

            <tr class="selected_second_level">
              <th scope="row">Totale</th>
              <td>
                {{calcolaSomma([
                  approssimaImporto(sorteTot),
                  approssimaImporto(interessiTot),
                  approssimaImporto(rivalutazioneTot)
                ])}} &euro;
              </td>
            </tr>
          </tbody>
        </table>


        <table class="fondo_rischi">
          <caption class="sr-only">Tabella compensi</caption>
          <tr class="selected_second_level">
            <th scope="row">Compensi professionali</th>
            <td>
            </td>
          </tr>
          <tr class="borded">
            <th scope="row">Diritti e onorari</th>
            <td>{{approssimaImporto(compensoTot) | euro}} &euro;</td>
          </tr>
          <tr class="borded">
            <th scope="row">Spese liquidate / cont. Un. /</th>
            <td>{{approssimaImporto(speseLiquidateTot) | euro}} &euro;</td>
          </tr>
          <tr class="borded">            
            <th scope="row">IRAP</th>
            <td>{{approssimaImporto(irapTot) | euro}} &euro;</td>
          </tr>
          <tr class="borded">
            <th scope="row">Oneri Riflessi</th>
            <td>{{approssimaImporto(oneriRiflessiTot) | euro}} &euro;</td>
          </tr>
          <tr class="borded">
              <th scope="row">Spese Marche/Notifica</th>
              <td>{{approssimaImporto(speseMarcheNotificaTot) | euro}} &euro;</td>
          </tr>
          <tr class="borded">
            <th scope="row">art.96 C.P.C.</th>
            <td>{{approssimaImporto(art96CPCTot) | euro}} &euro;</td>
          </tr>
          <tr class="borded">
            <th scope="row">F23</th>
            <td>{{approssimaImporto(f23Tot) | euro}} &euro;</td>
          </tr>
          <tr class="borded">
            <th scope="row">Risarcimento</th>
            <td>{{approssimaImporto(risarcimentoTot) | euro}} &euro;</td>
          </tr>
          <tr class="borded">
            <th scope="row" *ngIf="!listaEsiti || listaEsiti.length <= 0">Spese generali 0% art. 2</th>
            <th scope="row" *ngIf="listaEsiti[0] && listaEsiti[0].liquidati.length > 0">Spese generali {{listaEsiti[0].liquidati[0].costoGestioneLiquidato && listaEsiti[0].liquidati[0].costoGestioneLiquidato.speseGenerali ? listaEsiti[0].liquidati[0].costoGestioneLiquidato.speseGenerali : 0 }}% art. 2</th>
            <td>{{approssimaImporto(speseGenTot) | euro}} &euro;</td>
          </tr>
          <tr class="borded">
            <th scope="row">CPA</th>
            <td>{{approssimaImporto(cpaTot) | euro}} &euro;</td>
          </tr>
          <tr class="borded">
            <th scope="row">IVA</th>
            <td>{{approssimaImporto(ivaTot) | euro}} &euro;</td>
          </tr>
          <tr class="borded">
            <th scope="row">Ritenuta d'acconto</th>
            <td>{{approssimaImporto(ritenutaAccontoTot) | euro}} &euro;</td>
          </tr>
          <tr class="selected_second_level">
            <th scope="row">Totale</th>
            <td>{{ calcolaSomma([approssimaImporto(speseLiteTot), 0]) }} &euro;
            </td>
          </tr>
        </table>



        <table class="fondo_rischi">
          <caption class="sr-only">Tabella compensi</caption>

          <tbody>
            <tr class="selected_second_level">
              <th scope="row">Compensi professionali</th>
              <td></td>
            </tr>

            <tr class="borded">
              <th scope="row">Compenso</th>
              <td>{{approssimaImporto(compensoTot) | euro}} &euro;</td>
            </tr>

            <tr class="borded">
              <th scope="row">
                <ng-container *ngIf="!listaEsiti || listaEsiti.length <= 0">
                  Spese generali 0% art. 2
                </ng-container>
                <ng-container *ngIf="listaEsiti[0] && listaEsiti[0].liquidati.length > 0">
                  Spese generali {{
                    listaEsiti[0].liquidati[0].costoGestioneLiquidato &&
                    listaEsiti[0].liquidati[0].costoGestioneLiquidato.speseGenerali
                      ? listaEsiti[0].liquidati[0].costoGestioneLiquidato.speseGenerali
                      : 0
                  }}% art. 2
                </ng-container>
              </th>
              <td>{{approssimaImporto(speseGenTot) | euro}} &euro;</td>
            </tr>

            <tr class="borded">
              <th scope="row">CPA</th>
              <td>{{approssimaImporto(cpaTot) | euro}} &euro;</td>
            </tr>

            <tr class="borded">
              <th scope="row">IVA</th>
              <td>{{approssimaImporto(ivaTot) | euro}} &euro;</td>
            </tr>

            <tr class="borded">
              <th scope="row">Ritenuta d'acconto</th>
              <td>{{approssimaImporto(ritenutaAccontoTot) | euro}} &euro;</td>
            </tr>

            <tr class="selected_second_level">
              <th scope="row">Totale</th>
              <td>{{calcolaSomma([approssimaImporto(speseLiteTot), 0])}} &euro;</td>
            </tr>
          </tbody>
        </table>


        <table class="fondo_rischi">
          <caption class="sr-only">Tabella spese</caption>

          <tbody>
            <tr class="selected_second_level">
              <th scope="row">Spese vive</th>
              <td></td>
            </tr>

            <tr class="borded">
              <th scope="row">Spese di registrazione</th>
              <td>{{speseRegistrazioneTot | euro}} &euro;</td>
            </tr>

            <tr class="borded">
              <th scope="row">Contributo unificato</th>
              <td>{{contributoUnificatoTot | euro}} &euro;</td>
            </tr>

            <tr class="borded">
              <th scope="row">Altro importo</th>
              <td>{{altroImportoTot | euro}} &euro;</td>
            </tr>

            <tr class="selected_second_level">
              <th scope="row">Totale</th>
              <td>
                {{calcolaSomma([
                  approssimaImporto(speseRegistrazioneTot),
                  approssimaImporto(contributoUnificatoTot),
                  approssimaImporto(altroImportoTot)
                ])}} &euro;
              </td>
            </tr>
          </tbody>
        </table>


        <table class="fondo_rischi">
          <caption class="sr-only">Tabella totale</caption>

          <tbody>
            <tr class="selected_second_level">
              <th scope="row">Totale complessivo</th>
              <td>
                {{calcolaSomma([
                  approssimaImporto(sorteTot),
                  approssimaImporto(interessiTot),
                  approssimaImporto(rivalutazioneTot),
                  approssimaImporto(speseLiteTot),
                  approssimaImporto(speseRegistrazioneTot),
                  approssimaImporto(contributoUnificatoTot),
                  approssimaImporto(altroImportoTot)
                ])}} &euro;
              </td>
            </tr>
          </tbody>
        </table>

        <table class="fondo_rischi">
          <caption class="sr-only">Tabella liquidati</caption>

          <tbody>
            <tr class="selected_second_level">
              <th scope="row">Lista ripartizione Liquidati in sentenza: PER SOGGETTI</th>
              <td></td>
            </tr>
          </tbody>
        </table>

        <table class="table-striped table aggiunta_classificazione" *ngIf="listaLiquidati.length > 0">
          <caption class="sr-only">Tabella lista liquidati</caption>

          <thead>
            <tr>
              <th scope="col">Soggetto</th>
              <!-- <th scope="col">Società</th> -->
              <th scope="col">Importi</th>
              <th scope="col">Compensi professionali</th>
              <th scope="col">Spese vive</th>
              <!-- <th scope="col">Spese di lite</th> -->
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let liquidato of listaLiquidati">
              <td *ngIf="liquidato.controparte">{{ liquidato.controparte?.parte?.nominativo }}</td>
              <td *ngIf="liquidato.altraParte">{{ liquidato.altraParte?.parte?.nominativo }}</td>
              <td *ngIf="liquidato.legaleIncaricato">{{ liquidato.legaleIncaricato?.legale?.nominativo }}</td>
              <td *ngIf="!liquidato.controparte && !liquidato.altraParte && !liquidato.legaleIncaricato"></td>

              <td>
                <p>
                  {{
                    getSum(
                      approssimaImporto(liquidato.importoLiquidato?.importo),
                      approssimaImporto(liquidato.importoLiquidato?.interessi),
                      approssimaImporto(liquidato.importoLiquidato?.sanzioni)
                    ) | euro
                  }} &euro;
                </p>
              </td>

              <td>
                <div *ngIf="liquidato?.costoGestioneLiquidato">
                  <div *ngFor="let speseGeneraliRicalcolate of [( liquidato.costoGestioneLiquidato.compenso | percentage : liquidato.costoGestioneLiquidato.speseGenerali)] ">
                    <div *ngFor="let cpaImporto of [( liquidato.costoGestioneLiquidato.compenso | percentage : (liquidato.costoGestioneLiquidato &&  liquidato.costoGestioneLiquidato.cpa) ? liquidato.costoGestioneLiquidato.cpa.valore : 0 )]">
                      <div *ngFor="let ivaImporto of [( getSum( liquidato.costoGestioneLiquidato.compenso , cpaImporto ) | percentage : (liquidato.costoGestioneLiquidato &&  liquidato.costoGestioneLiquidato.iva) ?  liquidato.costoGestioneLiquidato.iva.valore : 0 )]">
                        <div *ngFor="let ritenutaAcconto of [( liquidato.costoGestioneLiquidato.flagRitenutaAcconto ? ( liquidato.costoGestioneLiquidato.compenso | percentage:20) : 0 )]">
                          <div *ngFor="let irapRiCalcolata of [( liquidato.costoGestioneLiquidato.irap ? (liquidato.costoGestioneLiquidato?.compenso * liquidato.costoGestioneLiquidato.irap / 100) : 0)]">
                            <div *ngFor="let oneriRiflessiRiCalcolati of [( liquidato.costoGestioneLiquidato.oneriRiflessi ? (liquidato.costoGestioneLiquidato?.compenso * liquidato.costoGestioneLiquidato.oneriRiflessi / 100) : 0)]">                          
                              <div *ngFor="let totSpeseLite of [( getDiff( getSum( liquidato.costoGestioneLiquidato.compenso , speseGeneraliRicalcolate, liquidato.costoGestioneLiquidato.speseLiquidate,
                                  irapRiCalcolata, oneriRiflessiRiCalcolati, liquidato.costoGestioneLiquidato.speseMarcheNotifica, liquidato.costoGestioneLiquidato.art96CPC, liquidato.costoGestioneLiquidato.f23, liquidato.costoGestioneLiquidato.risarcimento, cpaImporto , ivaImporto ) , ritenutaAcconto ))]">
                                {{ totSpeseLite }} &euro;
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>

              <td>
                <p>
                  {{
                    getSum(
                      approssimaImporto(liquidato.altroImportoLiquidato.speseRegistrazione),
                      approssimaImporto(liquidato.altroImportoLiquidato.contributoUnificato),
                      approssimaImporto(liquidato.altroImportoLiquidato.altroImporto),
                      approssimaImporto(liquidato.altroImportoLiquidato.rimborsoTerzoPignorato)
                    ) | euro
                  }} &euro;
                </p>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="row" *ngIf="listaLiquidati.length === 0">
          <p>Nessun soggetto presente</p>
        </div>
      </div>

    </div>
  </div>

  <div mod-esiti-liquidati-add (onReturn)="readSezioneEsiti()"
    (onLiquidatoInserito)="onCloseDialogAggiungiLiquidato($event)" [attr.id]="'modaladdliquidati'" #modaleLiquidatiEdit>
  </div>


</ng-template>